import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { ComparisonFeatureItem } from '@as/cotopaxi';
import { setTooltip } from '@as-react/common-utils';
import { GLOSSARY_KEY } from '../../../constants/GeneralConstants';
export const CompareFeatureItem = ({ feature, isGlossaryLoaded, shouldInitGlossaryTooltip, setSwiperInstance, }) => {
    const [isTooltipApplied, setIsTooltipApplied] = useState(false);
    const getGlossaryItem = (title, isLoaded) => { var _a; return isLoaded ? (_a = window[GLOSSARY_KEY]) === null || _a === void 0 ? void 0 : _a.find((glossary) => glossary.triggers.includes(title)) : null; };
    const glossaryItem = useMemo(() => getGlossaryItem(feature.title, isGlossaryLoaded), [feature, isGlossaryLoaded, shouldInitGlossaryTooltip]);
    const _setSwiperInstance = (swiper) => setSwiperInstance(swiper, feature.attribute);
    if (!!glossaryItem && !isTooltipApplied && shouldInitGlossaryTooltip) {
        setTooltip({
            element: `#feature-item-${feature.title}`,
            content: glossaryItem.description,
            title: glossaryItem.title,
            optionsOverride: {
                trigger: 'click',
            },
        });
        setIsTooltipApplied(true);
    }
    return (_jsx(ComparisonFeatureItem, { title: feature.title, values: feature.valuesByProducts, glossaryId: `feature-item-${feature.title}`, showGlossary: !!glossaryItem, setSwiperInstance: _setSwiperInstance }));
};
